<template>
    <div class="card" v-if="servicio">
        <div class="card-header bg-gray">
            <h3 class="card-title"><i class="fas fa-file-invoice mr-2"></i>{{no_factura==1 || compania_no_verifactu==1 ?'Registrar':$t('general.facturar')}}</h3>
            <div class="card-tools">
                <button type="button" class="btn btn-tool" data-card-widget="maximize">
                    <i class="fas fa-expand"></i>
                </button>
                <button type="button" class="btn btn-tool" data-card-widget="collapse">
                    <i class="fas fa-minus"></i>
                </button>
            </div>
        </div>
        <div class="card-body" v-if="sacarerror==true">
            <div v-if="errorvalidar=='Error: No hay trabajos para facturar.' || errorvalidar=='Error: No hay trabajos para registrar.'" class="alert alert-warning" role="alert">                
                <h4>{{ no_factura==1 || compania_no_verifactu==1 ? 'No hay trabajos para registrar':'No hay trabajos para facturar'}}</h4>
            </div>
            <div v-else class="alert alert-danger" role="alert">                
                <h4>{{ errorvalidar }}</h4>
            </div>
        </div>
        <div class="card-body" v-if="sacarerroryfacturar==true">
            <div class="alert alert-danger" role="alert">                
                <h4>{{ errorvalidar }}</h4>
            </div>
        </div>
        <div class="card-body" v-if="sacarerror==false && servicio.empresa_emisor_factura">            
            <div class="alert alert-danger" role="alert" v-if="servicio.reasignado==1">
                <h5>EXPEDIENTE REASIGNADO, ¿DESEA {{ no_factura==1 || compania_no_verifactu==1?'REGISTRARLO':'FACTURARLO' }} IGUALMENTE?</h5>
                <div class="custom-control custom-switch ">
                    <input type="checkbox" @click="finalizarsinfacturar()" checked class="custom-control-input"
                        id="facturar123">
                    <label class="custom-control-label" for="facturar123">{{textoreasignado}}</label>
                </div>
            </div>
            <TabView v-if="textoreasignado=='Si'">
                <TabPanel v-for="destinatariofactura of Object.entries(listatrabajosfacturar)"
                    :key="destinatariofactura" :header="destinatariofactura[0].replace(/_/g, ' ')">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="card card-widget">
                                <div class="card-body">
                                    <h4>{{ servicio.empresa_emisor_factura.nombre_empresa }}<br><small>CIF: {{
                                            servicio.empresa_emisor_factura.nif_empresa }}</small></h4>
                                    <p>
                                        {{ servicio.empresa_emisor_factura.direccion_empresa }}<br>
                                        {{ servicio.empresa_emisor_factura.codigo_postal_empresa }} {{
                                        servicio.empresa_emisor_factura.ciudad_empresa }} ({{
                                        servicio.empresa_emisor_factura.provincia_empresa
                                        }})<br>
                                        Telf: {{ servicio.empresa_emisor_factura.telefono_empresa }}<br>
                                        Email: {{ servicio.empresa_emisor_factura.email_empresa }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card card-widget">
                                <div class="card-body" v-if="destinatariofactura[0] =='Compañia'">
                                    <h4>{{ destinatariofactura[1].datos_facturacion.nombre }}<br><small>CIF: {{
                                            destinatariofactura[1].datos_facturacion.cif }}</small>

                                    </h4>
                                    <p>
                                        {{ destinatariofactura[1].datos_facturacion.domicilio }}<br>
                                        {{ destinatariofactura[1].datos_facturacion.cp }} {{
                                        destinatariofactura[1].datos_facturacion.poblacion }} ({{
                                        destinatariofactura[1].datos_facturacion.provincia }})<br>
                                        Telf: {{ destinatariofactura[1].datos_facturacion.telefono}}<br>
                                        Email: {{destinatariofactura[1].datos_facturacion.email}}
                                    </p>
                                </div>
                                <div class="card-body" v-if="destinatariofactura[0] != 'Compañia'" @click="console.log(destinatariofactura[1])">
                                    <h4>{{ destinatariofactura[1].datos_facturacion.nombre }}<br>
                                        <small v-if="destinatariofactura[1].datos_facturacion.cif">Nº de Identificación: {{
                                            destinatariofactura[1].datos_facturacion.cif }}</small>
                                        <small v-else>Nº de Identificación: {{
                                            destinatariofactura[1].datos_facturacion.nif }}</small>
                                    </h4>
                                    <p v-if="destinatariofactura[1].datos_facturacion.domicilio">
                                        {{ destinatariofactura[1].datos_facturacion.domicilio }}<br>
                                        {{ destinatariofactura[1].datos_facturacion.codigo_postal }} {{
                                        destinatariofactura[1].datos_facturacion.poblacion }} ({{
                                        destinatariofactura[1].datos_facturacion.provincia }})
                                        <br><br><br>
                                    </p>
                                    <p v-else>
                                        {{ destinatariofactura[1].datos_facturacion.direccion }}<br>
                                        {{ destinatariofactura[1].datos_facturacion.codigo_postal }} {{
                                        destinatariofactura[1].datos_facturacion.poblacion }} ({{
                                        destinatariofactura[1].datos_facturacion.provincia }})<br>
                                        Telf: {{ destinatariofactura[1].datos_facturacion.telefono1 }}<br>
                                        Email: {{ destinatariofactura[1].datos_facturacion.email }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="direccionesFacturacion.length > 0 && esDestinatarioCliente(destinatariofactura[0])">                        <div class="col-md-12">
                            <div class="card card-widget">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <b>El asegurado tiene estas otras direcciones. Desea {{ no_factura==1 || compania_no_verifactu==1?'registrar':'facturar' }} a alguna de
                                                ellas? </b>
                                        </div>
                                        <div class="col-md-12">
                                            <select class="form-control" v-model="direccion">
                                                <option value="">Facturar a la dirección por defecto</option>
                                                <option v-for="dir in direccionesFacturacion"
                                                    :key="dir.id"
                                                    :value="dir.id">
                                                    {{ dir.direccion }}&nbsp;,&nbsp;{{ dir.poblacion }}&nbsp;{{ dir.cp }}&nbsp;({{ dir.provincia }})
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card card-widget">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="exampleInputEmail1">{{ $t('general.tipo') }}</label>
                                                <select class="form-control" v-model="tipo_factura">
                                                    <option value="factura">{{ no_factura ==1 || compania_no_verifactu==1? 'Registro contable' : $t('general.factura') }}</option>
                                                    <option value="albaran"
                                                        v-if="datosfacturacion.tipo_factura_albaran == 1">{{
                                                        $t('general.albaran') }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group" v-if="datosfacturacion.series">
                                                <label for="exampleInputEmail1">Serie</label>
                                                <select class="form-control" v-model="serieseleccionada">
                                                    <option v-for="serie in datosfacturacion.series" :key="serie"
                                                        :value="serie.datos.id_serie">
                                                       {{ serie.datos.prefijo_factura_serie	 }} ({{ serie.datos.nombre_serie }})
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="mostrarHuecos && servicio.compania.sistema == 'AXA_WS'">
                                        <div class="col-md-5">
                                            <div v-if="cargandoPresupuestosAxa < 2" class="loading-spinner">
                                                <i class="fas fa-spinner fa-spin"></i> Cargando presupuestos AXA...
                                            </div>                                                
                                            <div v-else class="form-group">
                                                <label for="">Presupuestos y valoraciones de axa</label>
                                                <select class="form-control" v-model="presupuestoAxaSeleccionado">
                                                    <option value="">Seleccione un presupuesto/valoración</option>
                                                    <option v-for="presupuesto in presupuestosAFacturar" :key="presupuesto.id_presuval" :value="presupuesto">
                                                        ({{ presupuesto.tipoPrepVal }}) Nº:{{ presupuesto.id_presuval }}-{{ presupuesto.version }} Importe: {{ presupuesto.total }}€
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-5">
                                            <div style="max-height:  200px; overflow: auto; padding: 5px;" class="card card-outline" v-if="mostrarHuecos"> 
                                                <b>Nros. anteriores disponibles</b>
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th>Número</th>
                                                            <th>Fecha</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="hueco in listahuecos" :key="hueco.numero">
                                                            <td>{{ hueco.numero }}</td>
                                                            <td>{{ fechaesp(hueco.fecha) }}</td>
                                                            <td><input type="radio" :value="hueco" v-model="huecoElegido"></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div v-else-if="servicio.compania.sistema == 'AXA_WS'">                                                
                                                <div v-if="cargandoPresupuestosAxa < 2" class="loading-spinner">
                                                    <i class="fas fa-spinner fa-spin"></i> Cargando presupuestos AXA...
                                                </div>                                                
                                                <div v-else class="form-group">
                                                    <label for="">Presupuestos y valoraciones de axa</label>
                                                    <select class="form-control" v-model="presupuestoAxaSeleccionado">
                                                        <option value="">Seleccione un presupuesto/valoración</option>
                                                        <option v-for="presupuesto in presupuestosAFacturar" :key="presupuesto.id_presuval" :value="presupuesto">
                                                            ({{ presupuesto.tipoPrepVal }}) Nº:{{ presupuesto.id_presuval }}-{{ presupuesto.version }} Importe: {{ presupuesto.total }}€
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>                                        
                                        <div class="col-md-2" v-if="tipo_factura == 'factura'">
                                            <div class="form-group">
                                                <label>Nº</label><br>
                                                <input type="text" class="form-control" v-model="siguientenumero"
                                                    :disabled="obligsignumero" @blur="cambioNumManual()">
                                            </div>
                                        </div>
                                        <div class="col-md-2" v-if="tipo_factura == 'factura'">
                                            <div class="form-group">
                                                <label for="exampleInputEmail1">{{ $t('general.anyo') }}</label>
                                                <select class="form-control" v-model="anyo">
                                                    <option v-for="anyos in datosfacturacion.years" :key="anyos">
                                                        {{ anyos }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label for="exampleInputEmail1">{{
                                                    $t('general.fecha') }}</label>
                                                <input
                                                    :disabled="fechadeshab || datosfacturacion.establecer_fecha_factura != 1"
                                                    type="date" v-model="fechaseleccionada"
                                                    class="form-control input-sm">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="tipo_factura=='factura'">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="exampleInputEmail1">{{ $t('general.forma de pago')
                                                    }}</label>
                                                <select class="form-control" v-model="pagoseleccionado">
                                                    <option value="">Seleccione forma de pago</option>
                                                    <option v-for="pago in datosfacturacion.formas_pago" :value="pago"
                                                        :key="pago">
                                                        {{ pago }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6"
                                            v-if="pagoseleccionado == 'Giro Bancario' || pagoseleccionado == 'Transferencia Bancaria'">
                                            <div class="form-group">
                                                <label for="exampleInputEmail1">{{ $t('general.cuenta bancaria')
                                                    }}</label>
                                                <select class="form-control" v-model="cuentabancariaseleccionada">
                                                    <option value="">Seleccione número de cuenta</option>
                                                    <option v-for="cuenta in datosfacturacion.cuentas_bancarias"
                                                        :key="cuenta.id_cuenta" :value="cuenta.numero">
                                                        {{ cuenta.numero }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4" v-if="vencimientoactivado">
                                            <div class="form-group">
                                                <label for="exampleInputEmail1">{{ $t('general.vencimiento') }}</label>
                                                <input type="date" v-model="vencimiento" class="form-control input-sm">
                                            </div>
                                        </div>
                                        <div class="col-md-4" v-if="datosfacturacion.establecer_codigo_cliente">
                                            <div class="form-group">
                                                <label for="exampleInputEmail1">{{ $t('general.codigo cliente') }}</label>
                                                <input type="text" v-model="codigocliente"
                                                    class="form-control input-sm">
                                            </div>
                                        </div>
                                        <div class="col-md-4"
                                            v-if="datosfacturacion.sistema_compania.servicios_relacionados">
                                            <div class="form-group">
                                                <label for="exampleInputEmail1">{{ $t('general.gremio albaran') }}</label>
                                                <select v-model="especialidadseleccionada" class="form-control">
                                                    <option value="">{{ $t('general.seleccionar') }}</option>
                                                    <option
                                                        v-for="grm in datosfacturacion.sistema_compania.servicios_relacionados"
                                                        :key="grm">
                                                        {{ grm }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="card card-widget">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="exampleInputEmail1">{{ $t('general.descripcion') }}</label>
                                                <i class="fa fa-info-circle ml-2" aria-hidden="true" style="color:#ffc107;" :title="no_factura==1 || compania_no_verifactu == 1 ? 'Descripción' : 'Si la descripción de factura está vacía, VeriFactu utilizará el concepto del trabajo'"></i>
                                                <textarea class="form-control" v-model="descripcionfactura" rows="3"
                                                    :placeholder="$t('general.descripcion')"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <div class="custom-control custom-switch ">
                                                    <input type="checkbox" @click="ensenyarfotos=!ensenyarfotos"
                                                        class="custom-control-input" id="agregar_fotos_factura">
                                                    <label class="custom-control-label" for="agregar_fotos_factura">{{
                                                        $t('general.agregar fotos') }}</label> 
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12" v-if="ensenyarfotos">
                                            <facturacionfotos :id="id" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card card-widget" style="width: 100%;">
                            <div class="card-body">
                                <div class="col-md-12">
                                    <TabView v-if="datosfacturacion.equipos">
                                        <TabPanel v-for="equipo in datosfacturacion.equipos" :key="equipo"
                                            :header="equipo.nombre_equipo">
                                            <ul>
                                                <li>
                                                    Marca: {{equipo.marca}}
                                                </li>
                                                <li v-for="adicional in Object.entries(equipo.adicionales)"
                                                    :key="adicional">
                                                    {{adicional[0]}}:&nbsp;{{adicional[1]}}
                                                </li>
                                            </ul>
                                        </TabPanel>
                                    </TabView>
                                </div>
                            </div>
                        </div>
                        <facturacionnueva v-if="datosfacturacion" :listatrabajosfacturar="listatrabajosfacturar"
                            :destinatario="destinatariofactura" :ffac="ffac" :id="id" :facturar="facturar"
                            :servicio="servicio" :tipo_factura="tipo_factura" :serieseleccionada="serieseleccionada"
                            :numeroseleccionado="siguientenumero" :fechaseleccionada="fechaesp(fechaseleccionada)"
                            :asegurado="asegurado" :vencimiento="fechaesp(vencimiento)" :codigocliente="codigocliente"
                            :pagoseleccionado="pagoseleccionado"
                            :cuentabancariaseleccionada="cuentabancariaseleccionada"
                            :descripcionfactura="descripcionfactura"
                            :especialidadseleccionada="especialidadseleccionada" :datosfacturacion="datosfacturacion" />
                        <div class="col-md-12" v-if="destinatariofactura[1].mostrarTPV==true">
                            <div class="card card-widget">
                                <div class="card-header">
                                    <h3 class="card-title">Opciones de pago por TPV</h3>
                                </div>
                                <div class="card-body">
                                    <div style="display: flex; flex-direction: row; justify-content: space-between;">
                                        <div>
                                            <label for="descripcionPago">Descripción de pago</label>
                                        </div>
                                        <div style="display: flex; flex-direction: column; justify-content: end;">
                                            <div class="row" style="justify-content: end;">
                                                <span>Descripción de baremo</span>
                                                <input style="margin-left: 10px;" v-model="dsc[destinatariofactura[0]]"
                                                    value="1" type="radio">
                                            </div>
                                            <div class="row" style="justify-content: end;">
                                                <span>Introducir descripción</span>
                                                <input style="margin-left: 10px;" v-model="dsc[destinatariofactura[0]]"
                                                    value="2" type="radio">
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <textarea style="margin: 20px 0;width: 100%;" rows="4"
                                            v-model="descripcionPago[destinatariofactura[0]]"
                                            id="descripcionPago"></textarea>
                                    </div>
                                    <div style="display: flex; flex-direction: row; justify-content: space-between;">
                                        <label for="chk">Generar factura cuando se reciba el pago</label>
                                        <input v-model="factura[destinatariofactura[0]]" type="checkbox" id="chk">
                                    </div>
                                    <div v-if="destinatariofactura[1].datos_facturacion.nif == ''" class="row"
                                        style="margin-top: 20px;justify-content: end;">
                                        <span style="background-color: #FF7575;">¡Atención! El asegurado/cliente no
                                            tiene NIF</span>
                                    </div>
                                    <div
                                        style="margin-top: 10px;margin-bottom: 10px;display: flex; justify-content: space-between;">
                                        <label for="">Enviar enlace de pago</label>
                                        <div style="display: flex; flex-direction: column;">
                                            <div style="display: flex; justify-content: end;">
                                                <span>SMS</span>
                                                <input style="margin-left: 10px;" type="radio" id="sms"
                                                    v-model="smsemail[destinatariofactura[0]]" value="1">
                                            </div>
                                            <div style="display: flex; justify-content: end;">
                                                <span>Email</span>
                                                <input style="margin-left: 10px;" type="radio" id="email"
                                                    v-model="smsemail[destinatariofactura[0]]" value="2">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" style="justify-content: end;"
                                        v-if="destinatariofactura[1].datos_facturacion.nif == ''">
                                        <button disabled title="Enviar pago (El asegurado/cliente debe tener NIF)"><i
                                                class="fas fa-credit-card"></i></button>
                                    </div>
                                    <div v-else class="row" style="justify-content: end;">
                                        <button @click="enviarPago(destinatariofactura)" title="Enviar pago"><i
                                                class="fas fa-credit-card"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </TabPanel>
            </TabView>

        </div>

       
        <div class="card-footer">
            <button v-if="listatrabajosfacturar && sacarerror==false && textoreasignado=='Si'"
                class="btn btn-block btn-primary" @click.stop="facturarfactura()" type="button"><span v-if="tipo_factura == 'albaran'">Crear albarán</span><span v-else>{{no_factura==1 || compania_no_verifactu==1? 'Crear registro/s contable/s':'Crear factura/s'}}</span></button>
        </div>
    </div>

    <!-- Observaciones -->
    <div class="card" v-if="servicio">
        <div class="card-header bg-gray">
            <h3 class="card-title"><i class="fas fa-comment-dots mr-2"></i>{{$t('general.observaciones')}}</h3>
            <div class="card-tools">
                <button type="button" class="btn btn-tool" data-card-widget="maximize">
                    <i class="fas fa-expand"></i>
                </button>
                <button type="button" class="btn btn-tool" data-card-widget="collapse">
                    <i class="fas fa-minus"></i>
                </button>
            </div>
        </div>
        <div class="card-body">
            <div class="alert alert-warning" v-if="citasSinConfirmar.length > 0">
                <h5><i class="fas fa-exclamation-triangle mr-2"></i>{{ $t('general.citaspendientesdeconfirmar') }}</h5>
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Hora</th>
                            <th>Operario</th>
                            <th>Especialidad</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="cita in citasSinConfirmar" :key="cita.visita.idvisitador">
                            <td>{{ cita.visita.fecha }}</td>
                            <td>{{ cita.visita.hora }}</td>
                            <td>{{ cita.visita.nombre_operario }}</td>
                            <td>{{ cita.visita.nombre_especialidad }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi';
import facturacionnueva from './FacturacionNueva.vue';
import facturacionfotos from './FacturacionNueva/FacturacionNuevaFotos.vue';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import $ from 'jquery';

export default {
    props: ['id', 'servicio','ffac'],
    components: {
        facturacionnueva,
        facturacionfotos,
        TabView,
        TabPanel,
        
},
    data() {
        return {
            especialidades_axa_facturar:[],
            valoracionAxaSeleccionada: '',
            presupuestoAxaSeleccionado:'',
            no_factura: localStorage.getItem('no_factura'),
            sacarerroryfacturar:false,
            huecoElegido:'',
            mostrarHuecos:false,
            classdp:'',
            smsemail:[],
            dsc:[],
            listatrabajosfacturar: '',
            facturar: false,
            rendercompania: true,
            renderasegurado: false,
            renderperjudicado: false,
            datosfacturacion: false,
            lineasnueva: '',
            fechaseleccionada: '',
            especialidadseleccionada: '',
            asegurado: '',
            siguientenumero: '',
            numeroseleccionado: '',
            serieseleccionada: '',
            vencimiento: '',
            vencimientoactivado:false,
            codigocliente: '',
            cuentabancariaseleccionada: '',
            pagoseleccionado: '',
            descripcionfactura: '',
            lineas: '',
            tipo_factura: 'factura',
            cuentas: [],
            items: [],
            ensenyarfotos:false,
            errorvalidar: '',
            sacarerror: null,
            checked: true,
            textoreasignado: 'Si',
            listahuecos:[],
            anyo: new Date().getFullYear(),
            obligsignumero: false,
            fechadeshab:false,
            factura:[],
            direccion:"",
            descripcionPago:[],
            conceptoDespues:[],
            porcentajeDespues:[],
            valorDespues: [],
            fotos:'',
            compania_no_verifactu:false,
            gruposAfectadosPresupuestosCreados:[],
            presupuestosAFacturar:[],
            gruposAfectadosValoracionesCreadas:[],
            cargandoPresupuestosAxa:0,
            citasSinConfirmar: []
        }
    },
    computed: {
        direccionesFacturacion() {
            const dirs = this.datosfacturacion?.direcciones_facturacion;
            if (!dirs) return [];
            const lista = Array.isArray(dirs) ? dirs : Object.values(dirs);
            return lista.filter(d => d && d.id);
        }
    },
    methods: {
        cambioNumManual(){
            this.fechaseleccionada = new Date().toLocaleString();
            this.fechaseleccionada = String(this.fechaseleccionada);
            let aux = this.fechaseleccionada.split(',');
            this.fechaseleccionada = this.fechaing(aux[0]);
            this.huecoElegido = '';
        },
        
            fechaing(fecha) {
                const [dia, mes, año] = fecha.split("/");
                return `${año}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
            },
            fechaesp(fecha) {
                const [año, mes, dia] = fecha.split("-");
                return `${dia}/${mes}/${año}`;
            },
            async enviarPago(datosFact){
                let datos = datosFact[1];
                let nombre = datosFact[0];
                const api = new PwgsApi();
                if(this.factura[nombre]){
                    let body = {'id_cliente':datos.datos_facturacion.idcliente, 'tipo_envio':this.smsemail[nombre], 'tipo_texto_pago':this.dsc[nombre],
                    'texto':this.descripcionPago[nombre], 'genera_factura':this.factura[nombre], 'descuento':this.porcentajeDespues[nombre], 
                    'descuento_importe':this.valorDespues[nombre], 'concepto_descuento_factura':this.conceptoDespues[nombre], 
                    'cuenta_bancaria':this.cuentabancariaseleccionada, 'anyo':this.anyo, 'fecha_factura':this.fechaseleccionada};
                    
                    try{
                        const resp = await api.put('facturas/'+this.id+'/enviar-pago-tpv',body);
                        
                        if(resp == 'OK') {
                            this.$toast.add({ severity: 'success', summary: 'Enviado', detail: 'Pago enviado correctamente', life: 2000 });
                        }else{
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo enviar el pago', life: 5000 });
                        }
                    }catch(error){
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                    }
                }else{
                    
                    try{
                        const resp = await api.put('facturas/'+this.id+'/enviar-pago-tpv',{'id_cliente':datos.datos_facturacion.idcliente, 'tipo_envio':this.smsemail[nombre], 'tipo_texto_pago':this.dsc[nombre],
                        'texto':this.descripcionPago[nombre], 'genera_factura':this.factura[nombre]});
                        
                        if(resp == 'OK') {
                            this.$toast.add({ severity: 'success', summary: 'Enviado', detail: 'Pago enviado correctamente', life: 2000 });
                        }else{
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo enviar el pago', life: 5000 });
                        }
                    }catch(error){
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                    }
                }
            },
            modificarConceptoDespues(concepto, nombre){
                this.conceptoDespues[nombre] = concepto;
            },
            modificarValorDespues(valor, nombre){
                this.valorDespues[nombre] = valor;
            },
            modificarPorcentajeDespues(porcentaje, nombre){
                this.porcentajeDespues[nombre] = porcentaje;
            },
        async cargardatos() {
            this.cargandoPresupuestosAxa=0;
            this.presupuestoAxaSeleccionado = '';
            //POST  modulos/pwgsapi/index.php/facturas/:id_servicio/previo-facturacion
            const api = new PwgsApi();
            this.items = [];
            this.listatrabajosfacturar = [];
            this.listatrabajosfacturar = await api.post('facturas/' + this.$props.id + '/previo-facturacion');
            for (let tip of Object.entries(this.listatrabajosfacturar)) {
                let subidadatos = {label:tip[0]}
                this.items.push(subidadatos);
                let nombre = tip[0].split('_');
                if(nombre == 'Cliente' || nombre[0] == 'Perjudicado'){
                    this.valorDespues[tip[0]] = '';
                    this.porcentajeDespues[tip[0]] = '';
                    this.conceptoDespues[tip[0]] = '';
                    this.descripcionPago[tip[0]]= '';
                    this.factura[tip[0]] = true;
                    this.dsc[tip[0]] = 1;
                    this.smsemail[tip[0]] = 1;
                    let idcli = tip[1].datos_facturacion.idcliente;
                    let datosComun = await api.get('servicios/'+this.id+'/comunicaciones-ste/'+idcli);
                    if(datosComun.comunicaciones !=1 || datosComun.pasarela_pago !=1){
                        tip[1].mostrarTPV = false;
                    }
                    else{
                        tip[1].mostrarTPV = true;
                    }
                }else{
                    tip[1].mostrarTPV = false;
                }
            }
            if(this.servicio.compania.sistema=='AXA_WS'){
                this.presupuestosAFacturar = [];
                var datos = await api.post('servicios/' + this.id + '/oficios');
                var trabajos = await api.get('trabajos/'+ this.id + '/presuval-axa');
                var trabajosVal = await api.get('trabajos/'+ this.id + '/presuval-axa-val');
                this.cargarPresupuestosAxa(datos, trabajos);
                this.cargarValoraiconesAxa(datos, trabajosVal);
            }
            setTimeout(() => {
                this.mostrar();
            }, 1000);
            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },
        redondear(value) {
            return Number.isInteger(value)
                ? value
                : parseFloat(value.toFixed(2));
        },
        esDestinatarioCliente(clave){
            if(!clave) return false;
            const nombre = String(clave).replace(/_/g, ' ').trim().toLowerCase();
            if(nombre == 'cliente') return true;
            const destinatarios = this.datosfacturacion?.destinatarios || [];
            return destinatarios.some(d => String(d.tipo).toLowerCase() == 'cliente'
                && String(d.nombre).toLowerCase() == nombre);
        },
        async cargarPresupuestosAxa(datos, trabajos){            
            console.log('datoss', datos);
            if(!trabajos) trabajos = [];
            var creados = trabajos.filter(trabajo => trabajo.Enviado == 'S');
            if(datos.RepairEstimateValuationList){
                var afectadosPresupuestos = datos.RepairEstimateValuationList.Presupuestos.OficiosAfectado[0].Afectado;
                //var afectadosValoraciones = datos.RepairEstimateValuationList.Valoraciones.OficiosAfectado[0].Afectado;
            }
            try{
                const api = new PwgsApi();
                var gruposAfectadosPresupuestosCreados = [];
                console.log('temporales2', creados);
                //recorremos los trabajos obtenidos (los conectados con axa, es decir que tienen parametros de env�o)
                if(creados && creados.length>0){
                    var datosPresupuestos = await api.post('servicios/' + this.id + '/obtenerPresuval',  {tipo:'P'});
                }
                creados.forEach(tempo => {
                    
                    var presupuestosAxa = datosPresupuestos.RepairEstimateValuationList.Presupuestos.ListadoPresupuestos[0].Presupuesto;          
                    //buscamos su afectado y especialidad
                    var afectadoEncontrado = afectadosPresupuestos.find(afectado => afectado.IdAfectado == tempo.IdAfectado);
                    var especialidadEncontrada = afectadoEncontrado.Especialidades.find(especialidad => especialidad.IdEspecialidad == tempo.IdEspecialidad && especialidad.Indice == tempo.Indice);
                    console.log('tempo', tempo);
                    tempo.TotalConIva = this.redondear(parseFloat(tempo.TotalConIva));
                    tempo.TotalSinIva = this.redondear(parseFloat(tempo.TotalSinIva));
                    //cogemos solo los presupuestos
                    if(tempo.TipoPrepVal == 'P'){                  
                        var grupoAfectadoEncontrado = undefined;
                        
                        //AGRUPAMOS LOS TRABAJOS POR AFECTADO
    
                        //si no hay ningun grupo de afectados, creamos uno
                        if(gruposAfectadosPresupuestosCreados.length == 0){
                            var grupoAfectadoTemporal = {
                                afectado: afectadoEncontrado.NombreAfectado,
                                idAfectado: afectadoEncontrado.IdAfectado,
                                presupuestosCreados: [],
                            }
                            gruposAfectadosPresupuestosCreados.push(grupoAfectadoTemporal);
                            grupoAfectadoEncontrado = gruposAfectadosPresupuestosCreados[0];
                            console.log('llegacrea');
                        }else{
                            //si hay alguno ya creado, buscamos el que corresponda
                            grupoAfectadoEncontrado = gruposAfectadosPresupuestosCreados.find(afectado => afectado.idAfectado == tempo.IdAfectado);
                            console.log('llegaencuentra', gruposAfectadosPresupuestosCreados, grupoAfectadoEncontrado);
                        }
                        // si no hay un grupo de su afectado, lo creamos
                        if(grupoAfectadoEncontrado == undefined){
                            var grupoAfectadoTemporal2 = {
                                afectado: afectadoEncontrado.NombreAfectado,
                                idAfectado: afectadoEncontrado.IdAfectado,
                                presupuestosCreados: [],
                            }
                            gruposAfectadosPresupuestosCreados.push(grupoAfectadoTemporal2);
                            grupoAfectadoEncontrado = gruposAfectadosPresupuestosCreados[gruposAfectadosPresupuestosCreados.length-1];
                        }
                        
                        //ya tenemos el grupo de afectado al que pertenece, ahora agrupamos de este grupo por su presupuesto
    
                        //si el grupo de afectado al que pertenece no tiene ningun presupuesto, creamos uno
                        var grupoPresupuestoEncontrado = undefined;
                        var presupuestoAxaEncontrado = presupuestosAxa.find(presupuesto => presupuesto.IdPPTOVAL == tempo.id_presuval && presupuesto.Version == tempo.version);                     
                        if(grupoAfectadoEncontrado.presupuestosCreados.length == 0){   
                            var grupoPresupuestoCreado = {
                                id_afectado: afectadoEncontrado.IdAfectado,
                                tiene_visita:false,
                                tiene_desp:false,
                                tipo_encargo:'normal',
                                id_presuval: tempo.id_presuval,
                                version: tempo.version,
                                estado: presupuestoAxaEncontrado.Estado,
                                id_estado: presupuestoAxaEncontrado.IdEstado,
                                total: presupuestoAxaEncontrado.TotalPPTO,
                                especialidades:[],
                            }
                            console.log('presuaxaenc', presupuestoAxaEncontrado);
                            presupuestoAxaEncontrado.Oficios.forEach(oficio => {
                                console.log('entraoficio', oficio);
                                if(oficio.TotalVisita != '0' && oficio.TotalVisita != '0,00'){
                                    grupoPresupuestoCreado.tiene_visita = true;
                                }
                            })

                            if(presupuestoAxaEncontrado.TipoEncargo.includes('particular')){
                                grupoPresupuestoCreado.tipo_encargo = 'particular';
                            }
                            grupoAfectadoEncontrado.presupuestosCreados.push(grupoPresupuestoCreado);
                            grupoPresupuestoEncontrado = grupoAfectadoEncontrado.presupuestosCreados[0];
                        //si el grupo de afectado al que pertenece tiene al menos un presupuesto buscamos el suyo
                        }else{
                            console.log('llegaelse', grupoAfectadoEncontrado, especialidadEncontrada);
                            grupoPresupuestoEncontrado = grupoAfectadoEncontrado.presupuestosCreados.find(grupo => grupo.id_presuval == tempo.id_presuval && grupo.version == tempo.version);
                        }
    
                        //si no hay un grupo de presupuesto al que pertenece, lo creamos
                        if(grupoPresupuestoEncontrado == undefined){                        
                            var grupoPresupuestoCreado2 = {
                                id_afectado: afectadoEncontrado.IdAfectado,
                                tiene_visita:false,
                                tiene_desp:false,
                                tipo_encargo:'normal',
                                id_presuval: tempo.id_presuval,
                                version: tempo.version,
                                estado: presupuestoAxaEncontrado.Estado,
                                id_estado: presupuestoAxaEncontrado.IdEstado,
                                total: presupuestoAxaEncontrado.TotalPPTO,
                                especialidades:[],
                            }
                            if(presupuestoAxaEncontrado.TipoEncargo.includes('particular')){
                                grupoPresupuestoCreado2.tipo_encargo = 'particular';
                            }
                            presupuestoAxaEncontrado.Oficios.forEach(oficio => {
                                if(oficio.TotalVisita != '0' && oficio.TotalVisita != '0,00'){
                                    grupoPresupuestoCreado2.tiene_visita = true;
                                }
                            })
                            grupoAfectadoEncontrado.presupuestosCreados.push(grupoPresupuestoCreado2);
                            grupoPresupuestoEncontrado = grupoAfectadoEncontrado.presupuestosCreados[grupoAfectadoEncontrado.presupuestosCreados.length-1];
                        }
    
                        //ya tenemos el grupo de presupuesto al que pertenece, ahora agrupamos de este grupo por su especialidad
    
                        //si el grupo de presupuesto al que pertenece no tiene ningun grupo de especialidad, creamos uno
                        var especialidadesAxa = presupuestoAxaEncontrado.Oficios;
                        console.log('especialidades', especialidadesAxa, especialidadEncontrada);
                        var especialidadAxaEncontrada = especialidadesAxa.find(especialidad => especialidad.IdEspecialidad == especialidadEncontrada.IdEspecialidad && especialidad.IndiceEspecialidad == especialidadEncontrada.Indice);
                        console.log('especialidadAxaEncontrada', especialidadAxaEncontrada);
                        if(grupoPresupuestoEncontrado.especialidades.length == 0){                          
                            var grupoEspecialidadCreada= {
                                especialidad: especialidadEncontrada.NombreEspecialidad,
                                idEspecialidad: especialidadEncontrada.IdEspecialidad,
                                indice:especialidadEncontrada.Indice,
                                totalBaremo:0,
                                totalMateriales:0,
                                totalDesplazamiento:0,
                                totalIva:0,
                                total:0,
                                trabajos: [],
                                materiales: [],
                                desplazamiento:[],
                                comentario: especialidadAxaEncontrada.Comentario,
                                idProfesion: especialidadAxaEncontrada.IdProfesion,
                            };
                            if(tempo.PresupuestarPor == "BA"){
                                grupoEspecialidadCreada.presupuestarPor = "baremo";
                            }else{
                                grupoEspecialidadCreada.presupuestarPor = "M.O.";
                            }
                            if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                grupoEspecialidadCreada.totalBaremo = tempo.TotalConIva;
                                grupoEspecialidadCreada.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                            
                                grupoEspecialidadCreada.total = tempo.TotalConIva;
                                grupoEspecialidadCreada.trabajos.push(tempo);
                            }else if(tempo.trabajo.tipo_linea=='Materiales'){
                                grupoEspecialidadCreada.totalMateriales = tempo.TotalConIva;
                                grupoEspecialidadCreada.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                            
                                grupoEspecialidadCreada.total = tempo.TotalConIva;
                                grupoEspecialidadCreada.materiales.push(tempo);
                            }else if(tempo.trabajo.tipo_linea=='Desplazamiento'){
                                grupoEspecialidadCreada.totalDesplazamiento = tempo.TotalConIva;
                                grupoEspecialidadCreada.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                            
                                grupoEspecialidadCreada.total = tempo.TotalConIva;
                                grupoEspecialidadCreada.desplazamiento.push(tempo);
                            }
                           
                            grupoPresupuestoEncontrado.especialidades.push(grupoEspecialidadCreada);
                        //Si el grupo de presupuesto al que pertenece ya tiene algun grupo de epecialidad, miramos si hay un grupo para la especialidad en concreto
                        }else{
                            var grupoEncontrado = grupoPresupuestoEncontrado.especialidades.find(grupo => grupo.idEspecialidad == tempo.IdEspecialidad && grupo.indice == tempo.Indice);
                            //si existe el grupo de especialidad del trabajo lo a�adimos aqu�
                            if(grupoEncontrado){
                                console.log('grupoEncontrado', grupoEncontrado);
                                if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                    grupoEncontrado.totalBaremo = grupoEncontrado.totalBaremo+tempo.TotalConIva;
                                    grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                    grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                    grupoEncontrado.trabajos.push(tempo);
                                }else if(tempo.trabajo.tipo_linea=='Materiales'){
                                    grupoEncontrado.totalMateriales = grupoEncontrado.totalMateriales+tempo.TotalConIva;
                                    grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                    grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                    grupoEncontrado.materiales.push(tempo);
                                }else if(tempo.trabajo.tipo_linea == 'Desplazamiento'){
                                    grupoEncontrado.totalDesplazamiento = grupoEncontrado.totalDesplazamiento+tempo.TotalConIva;
                                    grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                    grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                    grupoEncontrado.desplazamiento.push(tempo);
                                }
                            //si no existe el grupo de especialidad del trabajo lo creamos
                            }else{                            
                                var grupoEspecialidadCreada2= {
                                    especialidad: especialidadEncontrada.NombreEspecialidad,
                                    idEspecialidad: especialidadEncontrada.IdEspecialidad,
                                    indice:especialidadEncontrada.Indice,
                                    totalBaremo:0,
                                    totalMateriales:0,
                                    totalDesplazamiento:0,
                                    totalIva:0,
                                    total:0,
                                    trabajos: [],
                                    materiales: [],
                                    desplazamiento:[],
                                    comentario: especialidadAxaEncontrada.Comentario,
                                    idProfesion: especialidadAxaEncontrada.IdProfesion,
                                };
                                if(tempo.PresupuestarPor == "BA"){
                                    grupoEspecialidadCreada2.presupuestarPor = "baremo";
                                }else{
                                    grupoEspecialidadCreada2.presupuestarPor = "M.O.";
                                }
                                if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                    grupoEspecialidadCreada2.totalBaremo = tempo.TotalConIva;
                                    grupoEspecialidadCreada2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                    grupoEspecialidadCreada2.total = tempo.TotalConIva;
                                    grupoEspecialidadCreada2.trabajos.push(tempo);
                                }else if(tempo.trabajo.tipo_linea=='Materiales'){
                                    grupoEspecialidadCreada2.totalMateriales = tempo.TotalConIva;
                                    grupoEspecialidadCreada2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                    grupoEspecialidadCreada2.total = tempo.TotalConIva;
                                    grupoEspecialidadCreada2.materiales.push(tempo);
                                }else if(tempo.trabajo.tipo_linea == 'Desplazamiento'){
                                    grupoEspecialidadCreada2.totalDesplazamiento = tempo.TotalConIva;
                                    grupoEspecialidadCreada2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                    grupoEspecialidadCreada2.total = tempo.TotalConIva;
                                    grupoEspecialidadCreada2.desplazamiento.push(tempo);
                                }
                                grupoPresupuestoEncontrado.especialidades.push(grupoEspecialidadCreada2);
                            }
                        }
                    }
                    
                });
                console.log('gruposAfectadis', gruposAfectadosPresupuestosCreados);
                gruposAfectadosPresupuestosCreados.forEach(grupo => {
                    grupo.presupuestosCreados.forEach(presupuesto => {
                        presupuesto.especialidades.forEach(especialidad => {
                            especialidad.total = parseFloat(especialidad.total).toFixed(2);
                            especialidad.totalIva = parseFloat(especialidad.totalIva).toFixed(2);
                            if(especialidad.desplazamiento.length > 0){
                                presupuesto.tiene_desp = true;
                            }
                        })
                    })
                })                
                gruposAfectadosPresupuestosCreados.forEach(grupo => {
                    grupo.presupuestosCreados.forEach(presupuesto => {
                        presupuesto.tipoPrepVal = 'Presupuesto';
                        if(presupuesto.id_estado == 1 && presupuesto.tiene_visita == false && presupuesto.tiene_desp == false && presupuesto.tipo_encargo == 'particular'){
                            //
                        }else if(presupuesto.id_estado == 1){
                            this.presupuestosAFacturar.push(presupuesto);
                        }else if(presupuesto.id_estado == 3 && presupuesto.tipo_encargo == 'normal'){
                            this.presupuestosAFacturar.push(presupuesto);
                        }
                    })
                })
                this.cargandoPresupuestosAxa++;
            }catch(e){
                this.cargandoPresupuestosAxa++;
                // this.$toast.add({ severity: 'error', summary: "Error", detail: e, life: 5000 });
                console.error(e);
            }
        },
        async cargarValoraiconesAxa(datos, trabajos){
            if(!trabajos) trabajos = [];
            var creados = trabajos.filter(trabajo => trabajo.Enviado == 'S');
            if(datos.RepairEstimateValuationList){
                var afectadosValoraciones = datos.RepairEstimateValuationList.Valoraciones.OficiosAfectado[0].Afectado;
            }
            console.log('afectadosValoraciones', datos);
            try{
                const api = new PwgsApi();
                var gruposAfectadosValoracionesCreadas = [];
                console.log('temporales2val', creados);
                //recorremos los trabajos obtenidos (los conectados con axa, es decir que tienen parametros de envío)
                if(creados && creados.length>0){
                    var datosValoraciones = await api.post('servicios/' + this.id + '/obtenerPresuval',  {tipo:'V'});
                }            
                creados.forEach(tempo => {      
                    var valoracionesAxa = datosValoraciones.RepairEstimateValuationList.Valoraciones.ListadoValoraciones[0].Valoracion;          
                    //buscamos su afectado y especialidad
                    var afectadoEncontrado = afectadosValoraciones.find(afectado => afectado.IdAfectado == tempo.IdAfectado);
                    var especialidadEncontrada = afectadoEncontrado.Especialidades.find(especialidad => especialidad.IdEspecialidad == tempo.IdEspecialidad && especialidad.Indice == tempo.Indice);
                    console.log('tempo', tempo);
                    tempo.TotalConIva = this.redondear(parseFloat(tempo.TotalConIva));
                    tempo.TotalSinIva = this.redondear(parseFloat(tempo.TotalSinIva));
                    //cogemos solo las valoraciones
                    if(tempo.TipoPrepVal == 'V'){
                        var grupoAfectadoEncontrado = undefined;
                        
                        //AGRUPAMOS LOS TRABAJOS POR AFECTADO
    
                        //si no hay ningun grupo de afectados, creamos uno
                        if(gruposAfectadosValoracionesCreadas.length == 0){
                            var grupoAfectadoTemporal = {
                                afectado: afectadoEncontrado.NombreAfectado,
                                idAfectado: afectadoEncontrado.IdAfectado,
                                valoracionesCreadas: [],
                            }
                            gruposAfectadosValoracionesCreadas.push(grupoAfectadoTemporal);
                            grupoAfectadoEncontrado = gruposAfectadosValoracionesCreadas[0];
                            console.log('llegacrea');
                        }else{
                            //si hay alguno ya creado, buscamos el que corresponda
                            grupoAfectadoEncontrado = gruposAfectadosValoracionesCreadas.find(afectado => afectado.idAfectado == tempo.IdAfectado);
                            console.log('llegaencuentra', gruposAfectadosValoracionesCreadas, grupoAfectadoEncontrado);
                        }
                        // si no hay un grupo de su afectado, lo creamos
                        if(grupoAfectadoEncontrado == undefined){
                            var grupoAfectadoTemporal2 = {
                                afectado: afectadoEncontrado.NombreAfectado,
                                idAfectado: afectadoEncontrado.IdAfectado,
                                valoracionesCreadas: [],
                            }
                            gruposAfectadosValoracionesCreadas.push(grupoAfectadoTemporal2);
                            grupoAfectadoEncontrado = gruposAfectadosValoracionesCreadas[gruposAfectadosValoracionesCreadas.length-1];
                        }
                        
                        //ya tenemos el grupo de afectado al que pertenece, ahora agrupamos de este grupo por su valoración
    
                        //si el grupo de afectado al que pertenece no tiene ninguna valoración, creamos una
                        var grupoValoracionEncontrada = undefined;
                        var valoracionAxaEncontrada = valoracionesAxa.find(valoracion => valoracion.IdPPTOVAL == tempo.id_presuval && valoracion.Version == tempo.version);                     
                        if(grupoAfectadoEncontrado.valoracionesCreadas.length == 0){
                            var grupoValoracionCreada = {
                                id_afectado: afectadoEncontrado.IdAfectado,
                                tiene_visita:false,
                                tiene_desp:false,
                                tipo_encargo:'normal',
                                id_presuval: tempo.id_presuval,
                                version: tempo.version,
                                estado: valoracionAxaEncontrada.Estado,
                                id_estado: valoracionAxaEncontrada.IdEstado,
                                total: valoracionAxaEncontrada.TotalPPTO,
                                especialidades:[],
                            }
                            console.log('presuaxaenc', valoracionAxaEncontrada);
                            valoracionAxaEncontrada.Oficios.forEach(oficio => {
                                console.log('entraoficio', oficio);
                                if(oficio.TotalVisita != '0' && oficio.TotalVisita != '0,00'){
                                    grupoValoracionCreada.tiene_visita = true;
                                }
                            })

                            if(valoracionAxaEncontrada.TipoEncargo.includes('particular')){
                                grupoValoracionCreada.tipo_encargo = 'particular';
                            }
                            grupoAfectadoEncontrado.valoracionesCreadas.push(grupoValoracionCreada);
                            grupoValoracionEncontrada = grupoAfectadoEncontrado.valoracionesCreadas[0];
                        //si el grupo de afectado al que pertenece tiene al menos una valoración buscamos el suyo
                        }else{
                            console.log('llegaelse', grupoAfectadoEncontrado, especialidadEncontrada);
                            grupoValoracionEncontrada = grupoAfectadoEncontrado.valoracionesCreadas.find(grupo => grupo.id_presuval == tempo.id_presuval && grupo.version == tempo.version);
                        }
    
                        //si no hay un grupo de valoracion al que pertenece, lo creamos
                        if(grupoValoracionEncontrada == undefined){                        
                            var grupoValoracionCreada2 = {
                                id_afectado: afectadoEncontrado.IdAfectado,
                                tiene_visita:false,
                                tiene_desp:false,
                                tipo_encargo:'normal',
                                id_presuval: tempo.id_presuval,
                                version: tempo.version,
                                estado: valoracionAxaEncontrada.Estado,
                                id_estado: valoracionAxaEncontrada.IdEstado,
                                total: valoracionAxaEncontrada.TotalPPTO,
                                especialidades:[],
                            }
                            if(valoracionAxaEncontrada.TipoEncargo.includes('particular')){
                                grupoValoracionCreada2.tipo_encargo = 'particular';
                            }
                            valoracionAxaEncontrada.Oficios.forEach(oficio => {
                                if(oficio.TotalVisita != '0' && oficio.TotalVisita != '0,00'){
                                    grupoValoracionCreada2.tiene_visita = true;
                                }
                            })
                            grupoAfectadoEncontrado.valoracionesCreadas.push(grupoValoracionCreada2);
                            grupoValoracionEncontrada = grupoAfectadoEncontrado.valoracionesCreadas[grupoAfectadoEncontrado.valoracionesCreadas.length-1];
                        }
    
                        //ya tenemos el grupo de valoracion al que pertenece, ahora agrupamos de este grupo por su especialidad
    
                        //si el grupo de valoracion al que pertenece no tiene ningun grupo de especialidad, creamos uno
                        var especialidadesAxa = valoracionAxaEncontrada.Oficios;
                        console.log('especialidades', especialidadesAxa, especialidadEncontrada);
                        var especialidadAxaEncontrada = especialidadesAxa.find(especialidad => especialidad.IdEspecialidad == especialidadEncontrada.IdEspecialidad && especialidad.IndiceEspecialidad == especialidadEncontrada.Indice);
                        console.log('especialidadAxaEncontrada', especialidadAxaEncontrada);
                        if(grupoValoracionEncontrada.especialidades.length == 0){                          
                            var grupoEspecialidadCreada= {
                                especialidad: especialidadEncontrada.NombreEspecialidad,
                                idEspecialidad: especialidadEncontrada.IdEspecialidad,
                                indice:especialidadEncontrada.Indice,
                                totalBaremo:0,
                                totalMateriales:0,
                                totalDesplazamiento:0,
                                totalIva:0,
                                total:0,
                                trabajos: [],
                                materiales: [],
                                desplazamiento:[],
                                comentario: especialidadAxaEncontrada.Comentario,
                                idProfesion: especialidadAxaEncontrada.IdProfesion,
                            };
                            if(tempo.PresupuestarPor == "BA"){
                                grupoEspecialidadCreada.presupuestarPor = "baremo";
                            }else{
                                grupoEspecialidadCreada.presupuestarPor = "M.O.";
                            }
                            if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                grupoEspecialidadCreada.totalBaremo = tempo.TotalConIva;
                                grupoEspecialidadCreada.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                            
                                grupoEspecialidadCreada.total = tempo.TotalConIva;
                                grupoEspecialidadCreada.trabajos.push(tempo);
                            }else if(tempo.trabajo.tipo_linea=='Materiales'){
                                grupoEspecialidadCreada.totalMateriales = tempo.TotalConIva;
                                grupoEspecialidadCreada.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                            
                                grupoEspecialidadCreada.total = tempo.TotalConIva;
                                grupoEspecialidadCreada.materiales.push(tempo);
                            }else if(tempo.trabajo.tipo_linea=='Desplazamiento'){
                                grupoEspecialidadCreada.totalDesplazamiento = tempo.TotalConIva;
                                grupoEspecialidadCreada.totalIva = tempo.TotalConIva-tempo.TotalSinIva;                            
                                grupoEspecialidadCreada.total = tempo.TotalConIva;
                                grupoEspecialidadCreada.desplazamiento.push(tempo);
                            }
                           
                            grupoValoracionEncontrada.especialidades.push(grupoEspecialidadCreada);
                        //Si el grupo de valoracion al que pertenece ya tiene algun grupo de epecialidad, miramos si hay un grupo para la especialidad en concreto
                        }else{
                            var grupoEncontrado = grupoValoracionEncontrada.especialidades.find(grupo => grupo.idEspecialidad == tempo.IdEspecialidad && grupo.indice == tempo.Indice);
                            //si existe el grupo de especialidad del trabajo lo a�adimos aqu�
                            if(grupoEncontrado){
                                console.log('grupoEncontrado', grupoEncontrado);
                                if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                    grupoEncontrado.totalBaremo = grupoEncontrado.totalBaremo+tempo.TotalConIva;
                                    grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                    grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                    grupoEncontrado.trabajos.push(tempo);
                                }else if(tempo.trabajo.tipo_linea=='Materiales'){
                                    grupoEncontrado.totalMateriales = grupoEncontrado.totalMateriales+tempo.TotalConIva;
                                    grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                    grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                    grupoEncontrado.materiales.push(tempo);
                                }else if(tempo.trabajo.tipo_linea == 'Desplazamiento'){
                                    grupoEncontrado.totalDesplazamiento = grupoEncontrado.totalDesplazamiento+tempo.TotalConIva;
                                    grupoEncontrado.totalIva = grupoEncontrado.totalIva+(tempo.TotalConIva-tempo.TotalSinIva);                                
                                    grupoEncontrado.total =  grupoEncontrado.total+tempo.TotalConIva;
                                    grupoEncontrado.desplazamiento.push(tempo);
                                }
                            //si no existe el grupo de especialidad del trabajo lo creamos
                            }else{                            
                                var grupoEspecialidadCreada2= {
                                    especialidad: especialidadEncontrada.NombreEspecialidad,
                                    idEspecialidad: especialidadEncontrada.IdEspecialidad,
                                    indice:especialidadEncontrada.Indice,
                                    totalBaremo:0,
                                    totalMateriales:0,
                                    totalDesplazamiento:0,
                                    totalIva:0,
                                    total:0,
                                    trabajos: [],
                                    materiales: [],
                                    desplazamiento:[],
                                    comentario: especialidadAxaEncontrada.Comentario,
                                    idProfesion: especialidadAxaEncontrada.IdProfesion,
                                };
                                if(tempo.PresupuestarPor == "BA"){
                                    grupoEspecialidadCreada2.presupuestarPor = "baremo";
                                }else{
                                    grupoEspecialidadCreada2.presupuestarPor = "M.O.";
                                }
                                if(tempo.trabajo.tipo_linea=='Baremo' || tempo.trabajo.tipo_linea=='MO'){
                                    grupoEspecialidadCreada2.totalBaremo = tempo.TotalConIva;
                                    grupoEspecialidadCreada2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                    grupoEspecialidadCreada2.total = tempo.TotalConIva;
                                    grupoEspecialidadCreada2.trabajos.push(tempo);
                                }else if(tempo.trabajo.tipo_linea=='Materiales'){
                                    grupoEspecialidadCreada2.totalMateriales = tempo.TotalConIva;
                                    grupoEspecialidadCreada2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                    grupoEspecialidadCreada2.total = tempo.TotalConIva;
                                    grupoEspecialidadCreada2.materiales.push(tempo);
                                }else if(tempo.trabajo.tipo_linea == 'Desplazamiento'){
                                    grupoEspecialidadCreada2.totalDesplazamiento = tempo.TotalConIva;
                                    grupoEspecialidadCreada2.totalIva = tempo.TotalConIva-tempo.TotalSinIva;
                                    grupoEspecialidadCreada2.total = tempo.TotalConIva;
                                    grupoEspecialidadCreada2.desplazamiento.push(tempo);
                                }
                                grupoValoracionEncontrada.especialidades.push(grupoEspecialidadCreada2);
                            }
                        }
                    }
                    
                });
                console.log('gruposAfectadisval', gruposAfectadosValoracionesCreadas);
                gruposAfectadosValoracionesCreadas.forEach(grupo => {
                    grupo.valoracionesCreadas.forEach(valoracion => {
                        valoracion.especialidades.forEach(especialidad => {
                            especialidad.total = parseFloat(especialidad.total).toFixed(2);
                            especialidad.totalIva = parseFloat(especialidad.totalIva).toFixed(2);
                            if(especialidad.desplazamiento.length > 0){
                                valoracion.tiene_desp = true;
                            }
                        })
                    })
                })
                console.log('gruposAfectadisval2', gruposAfectadosValoracionesCreadas, typeof gruposAfectadosValoracionesCreadas);
                gruposAfectadosValoracionesCreadas.forEach(grupo => {
                    console.log('grupo', grupo);
                    grupo.valoracionesCreadas.forEach(presupuesto => {
                        if(presupuesto.id_estado == 2){
                            presupuesto.val = true;
                            presupuesto.tipoPrepVal = 'Valoración';
                            this.presupuestosAFacturar.push(presupuesto);
                        }
                    })
                })
                console.log('valoracionesAFacturar', this.presupuestosAFacturar);
                this.cargandoPresupuestosAxa++;
            }catch(e){
                this.cargandoPresupuestosAxa++;
                // this.$toast.add({ severity: 'error', summary: "Error", detail: e, life: 5000 });
                console.error(e);
            }
            this.cargandoValoracionesAxa = false;
        },
        finalizarsinfacturar() {
            if(this.textoreasignado=='Si')
            { this.textoreasignado = "No"; }
            else{
                this.textoreasignado = "Si";
            }

        },

        async datoscliente() {
            //GET  modulos/pwgsapi/index.php/servicios/:id/clientes
            this.asegurado = '';
            var clientdatos = '';
            const api = new PwgsApi();
            clientdatos = await api.get('servicios/' + this.$props.id + '/clientes');
            this.asegurado = clientdatos.asegurado;
        },
        async cargarCuentas() {
            const api = new PwgsApi();
            let aux = await api.get('bancos/0/cuentas');
            for (let i = 0; i < aux.datos.length; i++) {
                this.cuentas[i] = aux.datos[i].iban_cuenta + "-" + aux.datos[i].iban2_cuenta + "-" + aux.datos[i].entidad_cuenta + "-" + aux.datos[i].oficina_cuenta + "-" + aux.datos[i].control_cuenta + "-" + aux.datos[i].numero_cuenta;
            }
        },
        async cargardatosfactura() {
            //GET  modulos/pwgsapi/index.php/facturas/:id_servicio/validar-facturacion
            const api = new PwgsApi();
            try{
                this.datosfacturacion = await api.get('facturas/' + this.$props.id + '/validar-facturacion');
                if(this.datosfacturacion.establecer_numero_factura == 1){
                    this.obligsignumero = false;
                }else{
                    this.obligsignumero = true;
                }
                if(this.datosfacturacion.cuentas_bancarias.length > 0){
                    let i=0;
                    this.datosfacturacion.cuentas_bancarias.forEach(aux => {
                        var cuenta =  aux.iban_cuenta + "-" + aux.iban2_cuenta + "-" + aux.entidad_cuenta + "-" + aux.oficina_cuenta + "-" + aux.control_cuenta + "-" + aux.numero_cuenta;                    
                        this.datosfacturacion.cuentas_bancarias[i].numero = cuenta;
                        i++;
                    });
                }
                this.pagoseleccionado = this.datosfacturacion.forma_pago_defecto;
                if(this.datosfacturacion?.cuenta_bancaria_defecto){
                    const cuentaId = this.datosfacturacion.cuenta_bancaria_defecto;
                    const cuentas = this.datosfacturacion.cuentas_bancarias || [];
                    const cuentaSeleccionada = cuentas.find(c => c.id_cuenta == cuentaId);

                    if(cuentaSeleccionada && typeof cuentaSeleccionada.numero !== 'undefined'){
                        this.cuentabancariaseleccionada = cuentaSeleccionada.numero;
                    }
                }
                if(this.datosfacturacion.dias_vencimiento_defecto){
                    this.vencimientoactivado = true;
                    this.vencimiento = this.addDaysToDate(this.fechaseleccionada, this.datosfacturacion.dias_vencimiento_defecto);
                }
                this.tipo_factura = this.datosfacturacion.tipo_factura_defecto;
                if(this.datosfacturacion.series?.length > 0){
                    this.serieseleccionada = this.datosfacturacion.series[0].datos.id_serie;
                }
                if(this.datosfacturacion.compania_no_verifactu > 0){
                    this.compania_no_verifactu = true;
                }else{
                    this.compania_no_verifactu = false;
                }
                this.sacarerror = false;
            }
             catch (error) {
                var partes = error.toString().split("No se puede facturar");
                if(partes.length == 2 && error.toString().includes("existen campos obligatorios pendientes de completar")){
                    this.sacarerroryfacturar = true;
                    this.sacarerror = false;
                }else{
                    this.sacarerroryfacturar = false;
                    this.sacarerror = true;
                }
                this.errorvalidar = error;
            }
            if (this.fechaseleccionada[9] == ",") { this.fechaseleccionada = this.fechaseleccionada.substring(0, 8) }
            this.direccion = "";
        },
        async siguientefactura() {
            //POST  modulos/pwgsapi/index.php/facturas/:id_servicio/siguiente-numero
            const api = new PwgsApi();
            let datos;
            let subidadatos = {year:this.anyo};
            this.huecoElegido = '';
            datos = await api.post('facturas/' + this.$props.id + '/siguiente-numero', subidadatos);
            if(this.serieseleccionada){
                console.log('entraserie', this.serieseleccionada);
                this.siguientenumero = datos[this.serieseleccionada].numero;
                if(datos[this.serieseleccionada].huecos_serie){
                    this.listahuecos = datos[this.serieseleccionada].huecos_serie;
                    if(this.tipo_factura == 'factura' && this.listahuecos.length > 0){
                        this.mostrarHuecos = true;
                    }else{
                        this.mostrarHuecos = false;
                    }
                }else{
                    this.mostrarHuecos = false;
                    this.listahuecos = [];
                }
            }else{
                console.log('entrarsinserie',datos);
                if(datos['s'] && datos['s'].huecos_serie){
                    this.siguientenumero = datos['s'].numero;
                    this.listahuecos = datos['s'].huecos_serie;
                    if(this.tipo_factura == 'factura' && this.listahuecos.length > 0){
                        this.mostrarHuecos = true;
                    }else{
                        this.mostrarHuecos = false;
                    }
                }else{
                    console.log('entrarsinserie2', datos);
                    this.mostrarHuecos = false;
                    this.listahuecos = [];
                }
            }
        },
        comprobarPresupuestoAxa(){
            console.log("this.presupuestoAxaSeleccionado",this.presupuestoAxaSeleccionado);
            console.log("this.listatrabajosfacturar",this.listatrabajosfacturar);
            var idsTrabajosMarcados = [];
            var idsTrabajosPresupuesto = [];
            if(Object.keys(this.listatrabajosfacturar).length != 1){
                alert('Debe haber solo un destinatario de factura para poder facturar presupuestos o valoraciones de AXA.');
                return false;
            }
            var error = false;
            for(let trabajo of Object.values(this.listatrabajosfacturar)){
                for(let tr of Object.values(trabajo.trabajos)){
                    if(tr.parametros_envio == '' || tr.parametros_envio.id_presuval != this.presupuestoAxaSeleccionado.id_presuval){
                        error = true;
                        break;
                    }
                }
                idsTrabajosMarcados = Object.keys(trabajo.trabajos);
            }
            if(error){
                alert('Los trabajos seleccionados deben pertenecer al presupuesto o valoración de AXA seleccionado.');
            }
            console.log('idsTrabajosMarcados',idsTrabajosMarcados);
            this.especialidades_axa_facturar = [];
            this.presupuestoAxaSeleccionado.especialidades.forEach(especialidad => {
                this.especialidades_axa_facturar.push(especialidad.idEspecialidad+'-'+especialidad.indice);
                especialidad.trabajos.forEach(trabajo => {
                    //las lineas de tipo trabajo se facturan solo las de tipo visita para valoraciones, para presupuestos todos
                    if(trabajo.TipoPrepVal!='V' || trabajo.trabajo.visita=='S'){
                        idsTrabajosPresupuesto.push(trabajo.id_trabajo);
                    }                    
                })
                especialidad.materiales.forEach(material => {
                    //las lineas de tipo material no se facturan si es valoración
                    if(material.TipoPrepVal!='V'){
                        idsTrabajosPresupuesto.push(material.id_trabajo);
                    }
                })
                especialidad.desplazamiento.forEach(desplazamiento => {
                    //las lineas de tipo desplazamiento se facturan todas
                    idsTrabajosPresupuesto.push(desplazamiento.id_trabajo);
                })
            })
            console.log('idsTrabajosPresupuesto',idsTrabajosPresupuesto);
            if(idsTrabajosMarcados.length != idsTrabajosPresupuesto.length){
                alert('Los trabajos marcados para facturar no se corresponden con los trabajos del presupuesto o valoración de AXA seleccionado.');
                return false;
            }else{
                return true;
            }
        },
        facturarfactura() {
            if(this.servicio.compania.sistema == "AXA_WS" && this.presupuestoAxaSeleccionado){
                if(this.comprobarPresupuestoAxa()){                    
                    this.facturar = !this.facturar;
                    this.$parent.movertoggle();
                }else{
                    return;
                }
            }else{
                this.facturar = !this.facturar;
                this.$parent.movertoggle();
            }
        },
        anyadirfotos(datos){
            this.fotos = datos;
        },
        mostrar() {

            if (this.listatrabajosfacturar.Cliente){
                $('#' + this.$props.id + ' a[href="#custom-tabs-two-Cliente"]').tab('show');
            }
            else {
                $('#' + this.$props.id +' a[href="#custom-tabs-two-Compañia"]').tab('show');

            }

        },
        addDaysToDate(initialDate, daysToAdd) {
            // Convertir la fecha inicial a un objeto Date
            const date = new Date(initialDate);
            // Sumar los días
            date.setDate(date.getDate() + parseInt(daysToAdd));
            
            // Formatear la fecha resultante a yyyy-mm-dd
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            
            return `${year}-${month}-${day}`;
        },        
        async facturacion(subidadatos) {
            //POST  modulos/pwgsapi/index.php/facturas/:id_servicio/facturar            
            const api = new PwgsApi();
            subidadatos.facturaAxa = '0';
            subidadatos.envioAxa = '';
            try {
                subidadatos.fotos = this.fotos;
                if(this.servicio.compania.sistema == "AXA_WS" && this.presupuestoAxaSeleccionado){
                    var tipo = 'P';
                    if(this.presupuestoAxaSeleccionado.tipoPrepVal == "Valoración"){
                        tipo = 'V';
                    }
                    subidadatos.especialidades_facturar = this.especialidades_axa_facturar;
                    subidadatos.facturaAxa = '1';
                    subidadatos.envio = {
                        TipoOperacion:'FACTURAR',
                        TipoPrepVal:tipo,
                        IdEncargo:"",
                        IdAfectado:this.presupuestoAxaSeleccionado.id_afectado,                    
                        IdPrepVal:this.presupuestoAxaSeleccionado.id_presuval,
                        Version:this.presupuestoAxaSeleccionado.version,
                        NumFactura:"",
                    }
                }
                if(this.direccion){
                    subidadatos.direccion_facturacion = this.direccion;
                }

                await api.post('facturas/' + this.$props.id + '/facturar', subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Documento/s creado/s correctamente', life: 2000 });                
                this.$parent.movertoggle();
                this.cargardatos();
                this.datoscliente();
                this.cargardatosfactura();
                this.obligsignumero = true;
                this.siguientefactura();
             }
            catch (error) {
                console.log("error123",error);
                const mensaje = error?.message;
                if(mensaje.includes('No se puede facturar porque el número de factura')){
                    this.siguientefactura();
                    console.log("subidadatos",subidadatos);
                    if (confirm(mensaje +'\n\n¿Facturar servicio con la empresa de la línea de facturación seleccionada?')) {
                        setTimeout(() => {
                            subidadatos.numero = this.siguientenumero;
                            console.log("subidadatos",subidadatos);
                            this.facturacion(subidadatos);
                        }, 1000);
                    }
                }else{
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                }
            }
        },
        reload(){
            this.fechaseleccionada = new Date().toLocaleString();
                this.fechaseleccionada = String(this.fechaseleccionada);
                let aux = this.fechaseleccionada.split(',');
                this.fechaseleccionada = this.fechaing(aux[0]);
            this.sacarerror = null;
            this.cargardatos();
            this.datoscliente();
            this.cargardatosfactura();
            this.obligsignumero = true;
            this.siguientefactura();
        },
        async obtenerCitasSinConfirmar(){
            try {
                const api = new PwgsApi();

                const citas = await api.get('/servicios/' + this.$props.id + '/visitas');
                this.citasSinConfirmar = (citas || []).filter(c => c.visita.confirmar == "1");
            } catch (e) {
                console.error('Error al obtener citas sin confirmar:', e);
                this.citasSinConfirmar = [];
            }

        }
    },
    mounted() {
        this.fechaseleccionada = new Date().toLocaleString();
                this.fechaseleccionada = String(this.fechaseleccionada);
                let aux = this.fechaseleccionada.split(',');
                this.fechaseleccionada = this.fechaing(aux[0]);
        this.cargardatos();
        this.datoscliente();
        this.cargardatosfactura();
        this.obligsignumero = true;
        this.siguientefactura();
        this.obtenerCitasSinConfirmar();
        
    },    
    watch: {
        huecoElegido(){
            if(this.huecoElegido!=''){
                this.siguientenumero = this.huecoElegido.numero;
                this.fechaseleccionada = this.huecoElegido.fecha;
            }else{
                this.fechaseleccionada = new Date().toLocaleString();
                this.fechaseleccionada = String(this.fechaseleccionada);
                let aux = this.fechaseleccionada.split(',');
                this.fechaseleccionada = this.fechaing(aux[0]);
            }
        },
        fechaseleccionada(){
            this.vencimiento = this.addDaysToDate(this.fechaseleccionada, this.datosfacturacion.dias_vencimiento_defecto);
        },
        tipo_factura() {
            if (this.tipo_factura == 'factura') {
                setTimeout(() => {
                    this.$refs.dp[0].show();

                },1000)

            }
            if(this.tipo_factura !== 'factura'){
                this.mostrarHuecos = false;
            }else{
                this.mostrarHuecos = true;
            }
            /*if (this.tipo_factura == 'albaran') {

            }*/
        },
        id() {
            this.fechaseleccionada = new Date().toLocaleString();
                this.fechaseleccionada = String(this.fechaseleccionada);
                let aux = this.fechaseleccionada.split(',');
                this.fechaseleccionada = this.fechaing(aux[0]);
            this.sacarerror = null;
            this.obligsignumero = true;
            this.cargardatos();
            this.datoscliente();
            this.cargardatosfactura();      
        },
        servicio(){
            this.fechaseleccionada = new Date().toLocaleString();
            this.fechaseleccionada = String(this.fechaseleccionada);
            let aux = this.fechaseleccionada.split(',');
            this.fechaseleccionada = this.fechaing(aux[0]);
            this.cargardatos();
            this.datoscliente();
        },
        anyo() {
            this.siguientefactura();
            
        },
        serieseleccionada() {
            this.siguientefactura();
        },
    }
}
</script>
<style>
.blue-arrow > .p-dropdown-trigger {
    color: blue;
}
</style>
<style scoped>
tbody tr:hover {
    background-color: rgba(0, 0, 0, 0.075);
    cursor: default;
}
</style>